<template>
  <div>
    <Pos_edit_product_data/>
  </div>
</template>

<script>
import Pos_edit_product_data from "@/components/adminArin/pos_system/warehouse/manage_product/Pos_edit_product_data";
export default {
  name: "PosEditProductData",
  components: {
    Pos_edit_product_data
  }
}
</script>

<style scoped>

</style>
